import { HttpService } from "../shared/http.service";

export class PopupService {
  $http = new HttpService();

  constructor() { }

  async findPopup() {
    const response = await this.$http.get("api/popups?populate=*&filters[ativo][$eq]=true");
    return response;
  }
}